__webpack_require__.p = "/elfsight-test-task/";